import { createFileRoute } from '@tanstack/react-router'
import { AuthRedirect } from '../../../src/pages/PICC/AuthRedirect'
import { piccAuthRedirectSearchSchema } from '../../../src/schemas/routeSchemas'

export const Route = createFileRoute('/picc/auth-redirect')({
  validateSearch: (search) => piccAuthRedirectSearchSchema.parse(search),
  loaderDeps: ({ search }) => ({ callback: search.callback }),
  staticData: {
    englishAllowed: true,
  },
  component: PiccAuthRedirectComponent,
})

function PiccAuthRedirectComponent() {
  const { callback } = Route.useSearch()

  return <AuthRedirect callback={callback} />
}
